import { PARTICIPANTS_CATEGORIES } from 'constants/participants'
import {
  ParticipantsCategory,
  ParticipantsSelection
} from 'types/typescript'
import { ReassignParticipants } from './types/reassignParticipants.types'
import {
  removeParticipantsWithBirthdates,
  getShouldAssignParticipantInCategory
} from '.'

export const reassignParticipants: ReassignParticipants = (
  packageConf,
  participants,
  participantsWithBirthdateList,
  { checkoutDate, shouldUpdateSelection } = {}
) => {
  const processedParticipants = removeParticipantsWithBirthdates(participants) as DeepWriteable<ParticipantsSelection>
  const categories = PARTICIPANTS_CATEGORIES as ParticipantsCategory[]

  for (let i = (participantsWithBirthdateList.length - 1); i >= 0; i--) {
    const { birthdate, origin } = participantsWithBirthdateList[i]

    for (let j = 0; j < categories.length; j++) {
      const category = categories[j]

      if (getShouldAssignParticipantInCategory(birthdate, category, packageConf, checkoutDate)) {
        processedParticipants[category].birthdates.unshift(birthdate)
        processedParticipants[category].number++
        participantsWithBirthdateList.pop()

        break
      }
    }

    if (shouldUpdateSelection && participantsWithBirthdateList.length !== i) {
      processedParticipants[origin].number++
      participantsWithBirthdateList.pop()
    } else if (participantsWithBirthdateList.length !== i) {
      throw new Error('At least one participant hasn\'t be assigned')
    }
  }

  return processedParticipants
}
